var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFixedSalary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 474.478 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6438",
    "data-name": "Group 6438",
    transform: "translate(11245 16754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9098",
    "data-name": "Path 9098",
    d: "M294.207,256A114.646,114.646,0,0,1,408.722,141.484V15a15,15,0,0,0-15-15H139.79V106.028a15,15,0,0,1-15,15H18.761V497a15,15,0,0,0,15,15h359.96a15,15,0,0,0,15-15V370.516A114.646,114.646,0,0,1,294.207,256ZM95.841,417.235c8.224,5.38,11.1,5.829,22.176,5.76a16.959,16.959,0,0,0,16.83-14.3c.819-4.873-.088-11.347-9.063-14.52-13.458-4.758-27.25-10.209-36.953-17.82-10.09-7.914-14.721-21.518-12.085-35.5,2.815-14.94,13.184-26.858,27.1-31.231v-3.076a15,15,0,0,1,30,0v2.613a50.224,50.224,0,0,1,15.726,7.675,15,15,0,0,1-17.963,24.027c-2.376-1.776-8.955-5.592-18.682-2.661-5.073,1.528-6.414,6.668-6.7,8.208-.583,3.092.142,5.576,1.12,6.343,6.315,4.954,17.918,9.422,28.436,13.14,20.709,7.32,32.223,26.521,28.649,47.778-2.554,15.193-13.477,30.587-30.583,36.644v4.537a15,15,0,0,1-30,0v-2.574c-8.127-1.131-15.138-3.853-24.431-9.933a15,15,0,1,1,16.424-25.1ZM313.717,442a15,15,0,0,1,0,30H249.484a15,15,0,0,1,0-30ZM73.73,171.029H247.97a15,15,0,1,1,0,30H73.73a15,15,0,0,1,0-30Zm0,60H217.968a15,15,0,1,1,0,30H73.73a15,15,0,1,1,0-30Z",
    transform: "translate(-11263.761 -16754)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9099",
    "data-name": "Path 9099",
    d: "M109.79,76.028V0L18.761,91.028H94.79A15,15,0,0,0,109.79,76.028Z",
    transform: "translate(-11263.761 -16754)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9100",
    "data-name": "Path 9100",
    d: "M408.723,171.484A84.516,84.516,0,1,0,493.239,256a84.611,84.611,0,0,0-84.516-84.516Zm46.032,72.966-44.313,44.313a15,15,0,0,1-21.212,0l-26.537-26.537a15,15,0,0,1,21.213-21.213l15.931,15.931,33.707-33.707a15,15,0,1,1,21.211,21.212Z",
    transform: "translate(-11263.761 -16754)",
    fill: "#1d3943"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixedSalary);
export default __webpack_public_path__ + "static/media/fixed_salary.726888ce157ec59f12e4967337b6fd21.svg";
export { ForwardRef as ReactComponent };